import { Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { ItemProps } from './ItemProps';

const Item = ({
  setTrackIsActive,
  setActiveItem,
  activeItem,
  constraint,
  isDragging,
  isSelectable,
  itemWidth,
  itemHeight,
  positions,
  children,
  direction,
  index,
  gap,
  onClickItem,
}: ItemProps) => {
  const [userDidTab, setUserDidTab] = useState(false);

  const handleFocus = () => setTrackIsActive(true);

  const handleBlur = () => {
    userDidTab && index + 1 === positions.length && setTrackIsActive(false);
    setUserDidTab(false);
  };

  const handleKeyUp = (event) =>
    event.key === 'Tab' &&
    !(activeItem === positions.length - constraint) &&
    setActiveItem((prev) => index);

  const handleKeyDown = (event) => event.key === 'Tab' && setUserDidTab(true);

  const handleClick = (event) => {
    if (isSelectable && !isDragging) {
      setActiveItem((prev) => index);
    }
    if (!isDragging) {
      onClickItem?.(index);
    }
  };

  return (
    <Flex
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyUp={handleKeyUp}
      onKeyDown={handleKeyDown}
      onClick={handleClick}
      h={itemHeight ? `${itemHeight}px` : 'auto'}
      w={`${itemWidth}px`}
      _notLast={{
        mb: direction === 'horizontal' ? '0px' : `${gap}px`,
        mr: direction === 'horizontal' ? `${gap}px` : '0px',
      }}
      px={direction === 'horizontal' ? '0px' : '4px'}
    >
      {children}
    </Flex>
  );
};

export default Item;
